module.exports = __webpack_public_path__ + "static/media/news1.95780278.png";